import React, { createContext, useEffect, useState, useContext } from 'react';
import {Alert} from 'react-bootstrap';

import './style.scss';

export const NotificationContext = createContext(null);

const DELAY = 3000;
let timer = null;

export const NotificationProvider = ({children}) => {
    const [notifications, setNotifications] = useState(null);

    useEffect(() => {
        if (notifications) {
            timer = setTimeout(() => {
                setNotifications(null);
            }, DELAY);
        } else {
            clearInterval(timer);
        }
    }, [notifications]);

    function showNotification({type = 'danger', message}) {
        if (notifications) {
            setNotifications(null);
            clearInterval(timer);
        }

        setNotifications({type, message});
    }

    const context = {
        showNotification,
    };

    return (
        <NotificationContext.Provider value={context}>
            <div className='notifications'>
                {
                    notifications &&
                    <Alert
                        bsStyle={notifications.type}
                    >
                        <p>
                            {notifications.message}
                        </p>
                    </Alert>
                    // notifications.map(({type, message}, index) => (
                    //     <Alert
                    //         key={index}
                    //         bsStyle={type}
                    //     >
                    //         <p>{message}</p>
                    //     </Alert>
                    // ))
                }
            </div>
            {children}
        </NotificationContext.Provider>
    )
}

export const useNotificationContext = () => useContext(NotificationContext);
